export const STATUS_TYPES = {
  UNLICENSED: "unlicensed",
  ARCHIVED: "archived",
  LICENSED: "licensed",
} as const;

export type UserStatus = (typeof STATUS_TYPES)[keyof typeof STATUS_TYPES];
